module.exports = __webpack_public_path__ + "assets/img/tx111.f27ca7b6.jpg";